import angular from 'angular'
import { normal } from 'redevConfig'
const list = (normal && normal.list) || ''

const normalList = list ? require(`redevelopment/statistics/normal/${list.templateName}`) : require('./view/normal.html')
const normalListCtrl = list ? require(`redevelopment/statistics/normal/${list.controllerName}`) : require('./normalCtrl.js')
export default angular
    .module('statistics.chartAnalysis.normal', [])
    .config(['$stateProvider', ($stateProvider) => {
        $stateProvider.state('statistics.chartAnalysis.normal', {
            url: '/normal',
            abstract: true,
            template: '<div ui-view></div>',
            default: 'statistics.chartAnalysis.normal.list',
        })
        $stateProvider.state('statistics.chartAnalysis.normal.list', {
            url: '/list/:obj',
            template: normalList,
            controller: 'normalListCtrl',
        })
    }])
    .controller('normalListCtrl', normalListCtrl.default)
    .name



// WEBPACK FOOTER //
// ./src/app/statistics/chartAnalysis/normal/index.js